import { Component, OnInit } from '@angular/core'
import { Router, RouterLink } from '@angular/router'
import { MatIcon } from '@angular/material/icon'
import { GlicoLogoComponent } from '../../../shared/components/glico-logo/glico-logo.component'
import { LISTROUTES } from '../../../core/template/routes'
import { MenuListModel } from '../../../core/models/menu.model'

interface Atalho {
  titulo: string
  descricao: string
  rota: string
  icone: string
}

// Atalhos da página inicial (exibidos conforme as permissões do usuário)
const ATALHOS: Atalho[] = [
  { titulo: 'Pacientes', descricao: 'Cadastro e acompanhamento dos pacientes.', rota: 'paciente', icone: 'groups' },
  { titulo: 'Pendências', descricao: 'Alertas que aguardam retorno da equipe.', rota: 'alertas-pendentes', icone: 'notifications_active' },
  { titulo: 'Relatório de medições', descricao: 'Histórico e evolução das leituras.', rota: 'relatorio-medicao', icone: 'insert_chart' },
  { titulo: 'Regras de alerta', descricao: 'Faixas de glicemia e classificação.', rota: 'regra-alerta', icone: 'rule' },
  { titulo: 'Mensageria', descricao: 'Mensagens enviadas pelo WhatsApp.', rota: 'mensageria', icone: 'forum' },
  { titulo: 'Unidades de saúde', descricao: 'Unidades e equipes vinculadas.', rota: 'unidade-saude', icone: 'local_hospital' },
]

@Component({
  selector: 'app-home',
  imports: [RouterLink, MatIcon, GlicoLogoComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  atalhos: Atalho[] = []
  nome = (localStorage.getItem('nomeUsuario') || 'Usuário').split(' ')[0]
  hoje = (() => {
    const d = new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' })
    return d.charAt(0).toUpperCase() + d.slice(1)
  })()

  constructor(private router: Router) {}

  navegar(rota: string, event?: Event) {
    if (event) {
      event.preventDefault()
    }
    const destino = rota.startsWith('/') ? rota : '/' + rota
    this.router.navigateByUrl(destino)
  }

  ngOnInit() {
    let permissoes: string[] = []
    try {
      const lista = JSON.parse(localStorage.getItem('permissions') || '[]')
      permissoes = lista.map((p: any) => 'view-' + p.modulo.toLowerCase().replaceAll(' ', '-').trim())
    } catch {
      permissoes = []
    }
    // Permissão de cada rota vem do mesmo menu usado pela sidebar
    const permissaoDaRota = new Map<string, string>()
    LISTROUTES.flatMap((m: MenuListModel) => [m, ...(m.children ?? [])]).forEach((item) => {
      if (item.route && item.permission) permissaoDaRota.set(item.route, item.permission)
    })
    this.atalhos = ATALHOS.filter((a) => permissoes.includes(permissaoDaRota.get(a.rota) ?? ''))
  }
}
